var React = require('react');

function NavIconsOrganizations (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m17.69 16.6-1.9-1.9 2.76-2.76-2.7-2.7 1.84-1.84a2.78 2.78 0 0 0 3.5-.4 2.78 2.78 0 1 0 -4.28-.43l-1.84 1.88-2.94-2.94-3.06 3.06-2-2a2.78 2.78 0 1 0 -3.85.79 2.8 2.8 0 0 0 3.07 0l2 2-2.59 2.58 2.64 2.64-2 2a2.78 2.78 0 1 0 .79.79l2-2 3 3 2.87-2.88 1.9 1.9a2.79 2.79 0 0 0 .35 3.5 2.78 2.78 0 0 0 3.93-3.89 2.76 2.76 0 0 0 -3.49-.36zm.31-12.7a1.67 1.67 0 1 1 0 2.35 1.65 1.65 0 0 1 -.48-1.17 1.63 1.63 0 0 1 .48-1.18zm-12 2.35a1.67 1.67 0 1 1 0-2.35 1.66 1.66 0 0 1 0 2.35zm0 13.85a1.67 1.67 0 1 1 0-2.36 1.67 1.67 0 0 1 0 2.36zm6.16-3.31-4.89-4.85 4.85-4.85 4.88 4.85zm8.24 3.31a1.67 1.67 0 0 1 -2.36 0 1.67 1.67 0 1 1 2.36 0z"}));
}

NavIconsOrganizations.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsOrganizations;

NavIconsOrganizations.default = NavIconsOrganizations;
